---
id: go-shared-llms
title: Shared LLM client
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - llm
  - openai
  - shared
---

## Product Overview

### Who it serves

This shared package provides a lightweight OpenAI client for Go services that need to issue LLM requests.

### Primary workflow

Services instantiate the OpenAI client with an API key, build a request payload, and invoke a request method to receive structured responses.

### Business rules

Requests are retried once on server errors, and common HTTP error cases are mapped to descriptive messages for callers.

### Outcomes

Services can reuse a single OpenAI request implementation without duplicating HTTP request logic.

### Out of scope

Prompt construction and model-specific business logic are owned by the calling services.

## Technical Overview

### Architecture flow

`OpenAI.Request` chooses the endpoint based on method metadata, sends JSON payloads to the OpenAI API, and unmarshals the response into a provided struct.

### Entry points

The main entry points are `NewOpenAI` and `OpenAI.Request` in `apps/micro-services/go-shared/llms/openai.go`.

### Key modules

`openai.go` defines method routing (`reqInfo`), model constants, response structs, and error handling for common OpenAI HTTP statuses.

### Data sources and sinks

The client sends HTTP requests to `https://api.openai.com/v1` and consumes JSON responses.

### Integrations and side effects

The package integrates directly with the OpenAI REST API and logs fatal errors when the API key is missing.

### Constraints and risks

If the API key is absent or rate limits are hit, requests fail, and the client does not implement advanced retry or backoff beyond a single retry on 500 responses.

## Changelog

- 2026-01-30: Initial documentation.
